import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import QuoteEditor from '@/routes/quotes/QuoteEditor'
import { quoteEditorRouteAction, quoteEditorRouteLoader } from '@/routes/quotes/QuoteEditor.route'
import { RoleRouteObject } from '@/types'

const QuoteCreatorRoute = {
  path: 'new',
  element: <QuoteEditor creating={true} />,
  loader: quoteEditorRouteLoader,
  action: quoteEditorRouteAction,
  allowedRoles: [Roles.Sales, Roles.Administrator, Roles.GlobalAdministrator, Roles.ExternalSales, Roles.Supervisor],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default QuoteCreatorRoute
